import Base from '@/Http';

export default class WorkHttp extends Base {
  constructor (enterpriseId:number, addUrl?:string) {
    super(addUrl);
    this.addUrl = `enterprise/${enterpriseId}`;
  }
}
